(function () {
  var content = document.querySelector('.m-article__content');
  var toc = document.getElementById('article-toc');
  if (!content || !toc) return;

  var headings = content.querySelectorAll('h2, h3');
  if (headings.length < 2) return;

  var list = toc.querySelector('.m-article-toc__list');
  var usedIds = {};

  headings.forEach(function (heading) {
    var text = heading.textContent.trim();
    if (!text) return;

    var id = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    if (usedIds[id]) {
      usedIds[id]++;
      id = id + '-' + usedIds[id];
    } else {
      usedIds[id] = 1;
    }
    heading.id = id;

    var li = document.createElement('li');
    li.className = heading.tagName === 'H3' ? 'm-article-toc__item m-article-toc__item--sub' : 'm-article-toc__item';
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = text;
    a.className = 'm-article-toc__link';
    li.appendChild(a);
    list.appendChild(li);
  });

  toc.style.display = '';

  // Toggle collapse
  var toggle = toc.querySelector('.m-article-toc__toggle');
  var nav = toc.querySelector('.m-article-toc__nav');
  toggle.addEventListener('click', function () {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    nav.style.display = expanded ? 'none' : '';
  });

  // Smooth scroll
  list.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') {
      e.preventDefault();
      var target = document.getElementById(e.target.getAttribute('href').slice(1));
      if (target) {
        var offset = 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', e.target.getAttribute('href'));
      }
    }
  });
})();
